<template>
  <div>
    <VueHtml2pdf :show-layout="true" :float-layout="true" :enable-download="true"
      :filename="`${ labelDefinition.projectTitle[lang] } - ${symbolCode}`" :pdf-quality="1" :manual-pagination="true" :pdf-format="isMobile() ? 'a5' : 'a2'"
      pdf-orientation="landscape" pdf-content-width="100%" pdf-content-height="100%" ref="exportable">
      <section slot="pdf-content" class="pdf-export" :class="$store.state.theme" :style="$commonHelper.resolveCssVars($commonHelper.getTemplateVars())">
        <loading :active="$store.state.setLoading" :can-cancel="false" :is-full-page="true"></loading>
        <Instagram id="InstagramPage" class="social-hide" :result="result" :bars="bars"
          v-if="result.last && instagramPage" :panel2hasMillion="panel2hasMillion" :panel3hasMillion="panel3hasMillion"
          :inflationAdjustmentPeriods="inflationAdjustmentPeriods" :period="period" :zeroPeriodForBarchart="zeroPeriodForBarchart"
          :adjusted="adjusted" :currency="currency" :is-unadjusted-symbol="result.isUnadjustedSymbol"></Instagram>
        <div id="HomePage" class="dashboard-bg" v-if="result.last && !isExport">
          <DashboardHeader :date="reportDate" @language-changed="languageChanged" @filter-changed="filterChanged" :class="isMobile() ? '' : 'home-padding'" :is-unadjusted-symbol="result.isUnadjustedSymbol"></DashboardHeader>
          <div class="row" :class="isMobile() ? '' : 'home-padding'">
            <div class="col col-md-3 col-lg-2 col-12">
              <div class="left-panel-row">
                <LeftArea v-if="symbolCode" :symbol-code="symbolCode" @symbol-selected="symbolSelected" @export-pdf="exportPdf">
                <template #items>
                  <LeftAreaItem :text="labelDefinition.price[lang]" :value="result.last"></LeftAreaItem>
                  <LeftAreaItem :text="labelDefinition.marketValue[lang]" :value="numberWithCommas(result.marketValue)"></LeftAreaItem>
                  <LeftAreaItem :text="labelDefinition.capital[lang]" :value="result.capital ? parseInt(result.capital) : 0"></LeftAreaItem>
                  <LeftAreaItem v-if="result.netLiability" :text="labelDefinition.netDebt[lang]" :value="result.netLiability"></LeftAreaItem>
                  <LeftAreaItem v-if="result.curPosNet" :text="`${labelDefinition.currencyPosition[lang]} (${result.curPosNetPeriod})`" :value="result.curPosNet" :last="true"></LeftAreaItem>
                </template>
              </LeftArea>
              </div>
            </div>
            <div class="col col-md-9 col-lg-10 col-12">
              <div class="row">
                <div class="col col-md-3 col-lg-3 col-12">
                  <SummaryPanel class="home-summary-panel" :row-count="dataDefinition[result.type]?.panel1?.length">
                    <template #header>
                      <SummaryPanelHeaderItem :text="labelDefinition.panel1Title[lang]" type="title" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                      <SummaryPanelHeaderItem v-for="(periodicData, index) in periodicData"
                        :text="getPeriod(periodicData.period)" v-bind:key="periodicData.period"
                        :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"
                        type="value" :text-align="index == 0 ? 'center' : 'end'"></SummaryPanelHeaderItem>
                    </template>
                    <template v-for="(def, index) in dataDefinition[result.type]?.panel1" :slot="`body${(index + 1)}`">
                      <SummaryPanelBodyItem v-bind:key="`panel1-title${index}`" type="text" :value="getPanelTitle(def)" font-size="0.85rem" font-weight="500">
                      </SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-for="(periodicData, index) in periodicData"
                        v-bind:key="`panel1-${periodicData.period + index}`"
                        :value="formatPercent((index == 0 ? result[def.value] : periodicData[def.value]), def.type, null, def.isEmpty, def.isPositive)"
                        :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '1rem'" type="value"
                        :text-align="index == 0 ? 'center' : 'end'"></SummaryPanelBodyItem>
                    </template>
                    <template #info v-if="result.type === 'factoring'">
                      <div class="summary-panel-info-template">{{ labelDefinition.factoringDescription[lang] }}</div>
                    </template>
                  </SummaryPanel>
                </div>
                <div class="col col-md-6 col-lg-5 col-12">
                  <SummaryPanel class="home-summary-panel" :row-count="dataDefinition[result.type]?.panel2?.length">
                    <template #header>
                      <SummaryPanelHeaderItem :text="labelDefinition.panel2Title[lang]" :sub-text="panel2hasMillion ? ' (x1000)' : ''" type="title" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                      <SummaryPanelHeaderItem v-for="(periodicData) in periodicData"
                        :text="getPeriod(periodicData.period)" v-bind:key="periodicData.period" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                      <SummaryPanelHeaderItem
                        v-if="periodicData?.length > 1" text="%" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                    </template>
                    <template v-for="(def, index) in dataDefinition[result.type]?.panel2" :slot="`body${(index + 1)}`">
                      <SummaryPanelBodyItem v-bind:key="`panel2-title${index}`" type="text" :value="getPanelTitle(def)" font-size="0.85rem" font-weight="500">
                      </SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-for="periodicData in periodicData"
                        v-bind:key="periodicData.period + index" type="value"
                        :value="formatThousand(periodicData[def.value], panel2hasMillion)" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '1rem'"></SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-bind:key="`panel2-value${index}`" v-if="periodicData?.length > 1"
                        type="value" :check-value="true"
                        :value="roundPercent(periodicData[0][def.value], periodicData[1][def.value], def.isNegativeValue, true)"
                        :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '1rem'"
                        :is-opposite="def.isOpposite">
                      </SummaryPanelBodyItem>
                    </template>
                  </SummaryPanel>
                </div>
                <div class="col col-md-3 col-lg-4 col-12">
                  <div class="summary-panel summary-panel-bg">
                    <div class="line-chart-panel-height">
                      <div class="title summary-panel-bg-title" :style="screenWidth > 768 && screenWidth <= 1700 ? { fontSize: '0.85rem' } : { fontSize: '0.95rem'}">{{ $commonHelper.toLocaleUpperCase(labelDefinition.priceGraphic[this.$store.state.lang]) }}</div>
                        <div class="period-area">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="period-box"
                                v-bind="attrs"
                                v-on="on"
                                :aria-label="periodSelectorLabel"
                              >
                                <span>{{ labelDefinition.periods[period][lang] }}</span> <v-icon aria-hidden="true">mdi-menu-down</v-icon>
                              </v-btn>
                            </template>
                            <v-list class="period-box-menu" role="menu">
                              <v-list-item
                                v-for="(item, index) in periods"
                                :key="index"
                                role="menuitemradio"
                                :aria-checked="period === item.key ? 'true' : 'false'"
                                :aria-label="getPeriodAriaLabel(item)"
                                @click="selectPeriod(item)"
                              >
                                <v-list-item-title>{{ item.value }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                        <div class="clear-both"></div>
                        <LineChart2 :series="series" :period="period" :theme="$store.state.theme" height="85%" width="100%" :screenWidth="screenWidth" :grid-display="true"></LineChart2>
                    </div>
                  </div>
                </div>
                <div class="col col-auto col-md-4 col-lg-4" v-for="def in dataDefinition[result.type]?.charts"
                  v-bind:key="def.value">
                  <div class="summary-panel summary-panel-bg">
                    <div class="title summary-panel-bg-title mb-2" :style="screenWidth > 768 && screenWidth <= 1700 ? { fontSize: '0.85rem' } : { fontSize: '0.95rem'}">{{ $commonHelper.toLocaleUpperCase(getChartTitle(def)) }}</div>
                    <div class="period-graphics">
                      <BarChart
                      :id="def.value"
                      :data="getChartValues(def.value)"
                      :inflationAdjustmentPeriods="inflationAdjustmentPeriods"
                      :zeroPeriodForBarchart="zeroPeriodForBarchart"
                      height="233px"
                      :font-size="14"
                      :gradient="true"
                      :theme="$store.state.theme"
                      :responsive="true"
                      :screen-width="screenWidth"
                      :grid-display="true"
                    ></BarChart>
                    </div>
                  </div>
                </div>
                <div class="col col-lg-5 col-md-5 col-12">
                  <SummaryPanel class="home-summary-panel" :row-count="dataDefinition[result.type]?.panel3?.length">
                    <template #header>
                      <SummaryPanelHeaderItem :text="labelDefinition.panel3Title[lang]" :sub-text="panel3hasMillion ? ' (x1000)' : ''" type="title" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                      <SummaryPanelHeaderItem v-for="(periodicData, index) in panel3PeriodicData"
                        :text="getPeriod(periodicData.period)" v-bind:key="periodicData.period"
                        :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'">
                        <template v-slot:sub-item v-if="index == 1 && !result.isUnadjustedSymbol && (periodicData.period % 100) !== 12">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>{{ labelDefinition.unadjustedBalanceSheetInfo[$store.state.lang] }}</span>
                        </v-tooltip>
                        </template>
                      </SummaryPanelHeaderItem>
                      <SummaryPanelHeaderItem v-if="showPanel3Percent" text="%" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                    </template>
                    <template v-for="(def, index) in dataDefinition[result.type]?.panel3" :slot="`body${(index + 1)}`">
                      <SummaryPanelBodyItem v-bind:key="`panel3-title${index}`" type="text" :value="def[lang]" font-size="0.85rem" font-weight="500">
                      </SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-for="periodicData in panel3PeriodicData"
                        v-bind:key="periodicData.period + index" type="value"
                        :value="formatThousand(periodicData[def.value], panel3hasMillion)" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '1rem'"></SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-bind:key="`panel3-value${index}`" v-if="showPanel3Percent"
                        type="value" :check-value="true"
                        :value="roundPercent(panel3PeriodicData[0][def.value], panel3PeriodicData[1][def.value], def.isNegativeValue, false)"
                        :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '1rem'"
                        :is-opposite="def.isOpposite">
                      </SummaryPanelBodyItem>
                    </template>
                  </SummaryPanel>
                </div>
                <div class="col col-lg-4 col-md-4 col-12">
                  <SummaryPanel class="home-summary-panel" :row-count="dataDefinition[result.type]?.panel4?.length">
                    <template #header>
                      <SummaryPanelHeaderItem :text="labelDefinition.panel4Title[lang]" type="title" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                      <SummaryPanelHeaderItem v-for="periodicData in periodicData"
                        :text="getPeriod(periodicData.period)" v-bind:key="periodicData.period"
                        :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                    </template>
                    <template v-for="(def, index) in dataDefinition[result.type]?.panel4" :slot="`body${(index + 1)}`">
                      <SummaryPanelBodyItem v-bind:key="`panel4-title${index}`" type="text" :value="getPanelTitle(def)" font-size="0.85rem" font-weight="500">
                      </SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-for="periodicData in periodicData"
                        v-bind:key="periodicData.period + index" type="value"
                        :value="formatPercent(periodicData[def.value], def.type)" font-size="1rem">
                      </SummaryPanelBodyItem>
                    </template>
                  </SummaryPanel>
                </div>
                <div class="col col-lg-3 col-md-3 col-12 max-width">
                  <SummaryPanel class="home-summary-panel" :row-count="dataDefinition[result.type]?.panel5?.length">
                    <template #header>
                      <SummaryPanelHeaderItem :text="labelDefinition.panel5Title[lang]" type="title" :font-size="screenWidth > 768 && screenWidth <= 1700 ? '0.85rem' : '0.95rem'"></SummaryPanelHeaderItem>
                      <td></td>
                    </template>
                    <template v-for="(def, index) in dataDefinition[result.type]?.panel5" :slot="`body${(index + 1)}`">
                      <SummaryPanelBodyItem v-bind:key="`panel5-title${index}`" type="text" :value="def[lang]" font-size="0.85rem" font-weight="500">
                      </SummaryPanelBodyItem>
                      <SummaryPanelBodyItem v-bind:key="`panel5-value${index}`" type="value"
                        :value="(def.value == 'peg' && !result.pegIsValid) ? 'A.D' : formatPercent(result[def.value], def.type)" font-size="1rem">
                      </SummaryPanelBodyItem>
                    </template>
                  </SummaryPanel>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-alert v-if="$store.state.showDeniedMessage" type="error" class="alert-error-background"> <p class="ml-1">Bu sayfa sadece uygulamalardan görüntülenebilmektedir.</p></v-alert>
        <v-alert v-if="showNotFoundError && !$store.state.showDeniedMessage && !result.last" type="error" class="alert-error-background"><p class="ml-1">Hisse Senedi Bulunamadı!</p></v-alert>
      </section>
    </VueHtml2pdf>
  </div>
</template>
<script>

import BarChart from './BarChart.vue';
import LineChart2 from './LineChart2.vue';
import DashboardHeader from './DashboardHeader.vue';
import LeftArea from './LeftArea.vue';
import LeftAreaItem from './LeftAreaItem.vue'
import SummaryPanel from './SummaryPanel.vue';
import SummaryPanelBodyItem from './SummaryPanelBodyItem.vue';
import SummaryPanelHeaderItem from './SummaryPanelHeaderItem.vue';
import definition from '../data-definition';
import Instagram from './Instagram.vue';
import VueHtml2pdf from 'vue-html2pdf';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { jwtDecode } from 'jwt-decode';

export default {
  name: 'Home-Page',
  components: {
    BarChart,
    LineChart2,
    DashboardHeader,
    LeftArea,
    LeftAreaItem,
    SummaryPanel,
    SummaryPanelBodyItem,
    SummaryPanelHeaderItem,
    Instagram,
    VueHtml2pdf,
    Loading
  },
  data() {
    return {
      symbolCode: '',
      result: {},
      lastFivePeriods: [],
      dataDefinition: definition.dataDefinition,
      labelDefinition: definition.labelDefinition,
      reportDate: '',
      startDate: '',
      endDate: '',
      bars: [],
      lang: 'tr',
      showNotFoundError: false,
      panel2hasMillion: false,
      panel3hasMillion: false,
      inflationAdjustmentPeriods: null,
      period: 'yearly',
      instagramPage: true,
      screenWidth: 0,
      zeroPeriodForBarchart: false,
      periodicData: [],
      adjusted: true,
      currency: 'TRY',
      divisorSymbol: '',
      divisorSymbolMap: {
        TRY: '',
        USD: 'USDTRY',
        EUR: 'EURTRY'
      },
      isExport: false
    }
  },
  async mounted() {
    if (window.self !== window.top) {
      const targetOrigin = window.document.referrer || '*';
      window.parent.postMessage({ message: 'READY' }, targetOrigin);

      window.addEventListener('message', event => {
        if (event.data && event.data.token){
          if (event.data.export === true && event.data.exportKey === this.$store.state.exportKey) {
            const theme = event.data.theme && ['light', 'dark'].includes(event.data.theme) ? `${event.data.theme}-theme` : 'dark-theme';
            this.$store.commit('set', ['theme', theme]);
            this.$store.commit('set', ['template', 'default']);
            this.initData(event.data.token, true);
          } else if (this.$store.state.parentDomains.includes(event.origin)) {
            const lang = event.data.lang && ['tr', 'en'].includes(event.data.lang) ? event.data.lang : 'tr';
            this.$store.commit('set', ['lang', lang]);
            this.lang = lang;
            const theme = event.data.theme && ['light', 'dark'].includes(event.data.theme) ? `${event.data.theme}-theme` : 'dark-theme';
            this.$store.commit('set', ['theme', theme]);
            const token = event.data.token;
            const decoded = jwtDecode(token);
            const template = this.$store.state.issuerTemplates[decoded?.iss] || 'default';
            this.$store.commit('set', ['template', template]);
            this.initData(token, false);
        
            if (event.data.hideLogo === true) {
              this.$store.commit('set', ['hideLogo', true]);
            }
        } else {
          this.$store.commit('set', ['showDeniedMessage', true]);
        } 
      }
      });
    } else {
      this.$store.commit('set', ['showDeniedMessage', true]);
    }
  },
  computed: {
    series() {
      return [{
        data: this.bars?.map(r => {
          const date = new Date(r.time);
          return {
            x: new Date(date.getTime()),
            y: r.close
          }
        }),
        name: ''
      }]
    },
    periods() {
      return [{
        key: 'daily',
        value: this.labelDefinition.periods.daily[this.lang]
      }, {
        key: 'weekly',
        value: this.labelDefinition.periods.weekly[this.lang]
      }, {
        key: 'monthly',
        value: this.labelDefinition.periods.monthly[this.lang]
      }, {
        key: 'yearly',
        value: this.labelDefinition.periods.yearly[this.lang]
      }]
    },
    periodSelectorLabel() {
      const currentPeriod = this.labelDefinition.periods[this.period][this.lang];
      return `${this.labelDefinition.periodSelect[this.lang]}: ${currentPeriod}`;
    },
    panel3Defs() {
      return this.dataDefinition[this.result.type]?.panel3 || [];
    },
    panel3PeriodicData() {
      return this.$commonHelper.filterZeroPanelColumns(this.periodicData, this.panel3Defs);
    },
    showPanel3Percent() {
      if (this.panel3PeriodicData.length < 2) {
        return false;
      }

      return this.$commonHelper.shouldShowPanelPercentColumn(this.panel3Defs, (def) =>
        this.roundPercent(
          this.panel3PeriodicData[0][def.value],
          this.panel3PeriodicData[1][def.value],
          def.isNegativeValue,
          false
        )
      );
    }
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    isNotMobileWidth() {
      return this.screenWidth >= 1300;
    },
    onResize() {
      this.screenWidth =  window.innerWidth;
    },
    async getData() {
      if (this.symbolCode) {
        try {
          this.lastFivePeriods = [];
          this.result = await this.$api.get(`dumrul/v1/fundamental-dashboard?symbol=${this.symbolCode}&unadjusted=${!this.adjusted}&currency=${this.currency}`);

          this.setReportDate();
          if (this.result) {
            this.getBars();

            this.result.last = parseFloat(this.result.last.toFixed(2));
            this.result.netLiability = parseFloat(this.result.netLiability?.toFixed(0));
            this.result.curPosNet = parseFloat(this.result.curPosNet?.toFixed(0));
            this.result.capital = parseFloat(this.result.capital?.toFixed(0));

            this.lastFivePeriods = this.result.lastFivePeriods.sort((a, b) => a.period - b.period);
            this.zeroPeriodForBarchart = !this.result.isUnadjustedSymbol
              && this.lastFivePeriods && this.lastFivePeriods[this.lastFivePeriods.length -1]?.period == this.$store.state.CHECK_ZERO_BARCHART_PERIOD;
            
            if (this.result.periodicData.length == 3) {
              this.periodicData = [this.result.periodicData[0], this.result.periodicData[2]];
            } else if (this.result.periodicData.length == 2) {
              const lastPeriod = this.result.periodicData[0]?.period;
              const prevPeriod = lastPeriod - 100;

              if (this.result.periodicData[1]?.period == prevPeriod) {
                this.periodicData = this.result.periodicData;
              } else {
                this.periodicData = [this.result.periodicData[0]];
              }

            } else if (this.result.periodicData.length == 1) {
              this.periodicData = [this.result.periodicData[0]];
            } else {
              this.periodicData = [];
            }

            this.panel2hasMillion = true; //this.hasMillion(this.periodicData, this.dataDefinition[this.result.type]?.panel2);
            this.panel3hasMillion = true; //this.hasMillion(this.periodicData, this.dataDefinition[this.result.type]?.panel3);
            this.inflationAdjustmentPeriods = this.getInflationAdjustmentPeriods(this.result);
          } else {
            this.result = {};
          }
          this.showNotFoundError = true;
        } catch (error) {
          this.showNotFoundError = true;
        }
      }
    },
    async symbolSelected(symbol) {
      this.symbolCode = symbol?.symbolCode;
      this.getData();
    },
    languageChanged(lang) {
      this.lang = lang;
      this.setReportDate();
      this.instagramPage = false;
      setTimeout(() => {
        this.instagramPage = true;
      }, 100);
      this.$forceUpdate();
    },
    filterChanged(adjusted, currency) {
      this.adjusted = adjusted;
      this.currency = currency;
      this.setReportDate();
      this.divisorSymbol = this.divisorSymbolMap[this.currency]
      this.getData();
    },
    setReportDate() {
      const date = new Date();
      const desktopOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
      const mobileOptions = {  hour: 'numeric', minute: 'numeric' };
      const lang = this.$store.state.lang === 'tr' ? 'tr-TR' : 'en-US';
      this.reportDate = date.toLocaleString(lang, this.isMobile() ? mobileOptions : desktopOptions); //1 Haziaran 2023 16:21
    },
    formatDecimal(value) {
      return value ? value.toFixed(4).replace('.', ',') : '0';
    },
    getPeriod(value) {
      const str = value ? value.toString() : '';
      return str && str.length == 6 ? `${str.slice(0, 4)}/${str.slice(4)}` : ''
    },
    formatThousand(value, hasMillion) {
      if (hasMillion) {
        value = parseInt(value / 1000).toString();
      } else {
        value = value ? value.toString() : '0';
      }
     
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(value))
        value = value.replace(pattern, "$1.$2");
      return value;
    },
    formatPercent(value, type, fraction, isEmpty, isPositive) {
      if (isEmpty) {
        return '';
      } else {
        const suffix = type == 'number' ? '' : '%';
        return (value ? (value < 0 && isPositive ? '-' : `${value.toFixed(fraction || 2)}${suffix}`) : '-');
      }
    },
    roundPercent(last, first, isNegativeValue, isIncome) {
      if (last && first) {
        if ((last < 0 && first > 0) || (last > 0 && first < 0) || (isIncome && last < 0 && first < 0 && last > first)) {
          return 'A.D';
        } else {
          const result = ((last - first) / Math.abs(first)) * 100;
          const value = last < 0 && first < 0 && isNegativeValue ? Math.abs(result) : result;
          return `${Math.round(value).toString()}%`;
        }
      }
  
      return '-';
    },
    getChartValues(key) {
      return this.lastFivePeriods.map(l => {
        return {
          text: this.getPeriod(l.period),
          value: l[key],
          period: l.period
        }
      });
    },
    async getBars() {
      const date = new Date();
      this.endDate = date.toISOString().substring(0, 10);
      let barPeriod = '';

      if (this.period === 'yearly') {
        date.setFullYear(date.getFullYear() - 1);
        barPeriod = 'monthly';
      } else if (this.period === 'monthly') {
        date.setMonth(date.getMonth() - 1);
        barPeriod = '1day'
      } else if (this.period === 'weekly') {
        date.setDate(date.getDate() -7);
        barPeriod = '1day'
      } else if (this.period === 'daily') {
        barPeriod = '5min';
      }
      this.startDate = date.toISOString().substring(0, 10);
      this.bars = [];

      const apiName = this.period === 'yearly' ? 'derived-bar' : 'bar';
      this.bars = await this.$api.get(`dumrul/v1/tick/${apiName}?symbol=${this.symbolCode}&period=${barPeriod}&start=${this.startDate}&end=${this.endDate}&divisorSymbol=${this.divisorSymbol}`, true);
    },
    exportPdf() {
      this.$refs.exportable.generatePdf();
    },
    async setSymbols() {
      const allSymbols = await this.$api.get(`dumrul/v3/meta/symbols?symbolType=S&marketCode=Z,N,T,S,W`) || [];
      const symbols = allSymbols.map(s => {
          return {
              symbolCode: s.symbolCode,
              description: s.description,
              exchangeCode: s.exchangeCode === 'BISTPP' ? 'IST' : s.exchangeCode
          }
      }).sort((a, b) => a.description < b.description ? -1 : 1);
     
      localStorage.setItem('symbols', JSON.stringify(symbols));
      localStorage.setItem('symbols_timespan', new Date().getTime());
      this.$store.commit('set', ['symbols', symbols]);
    },
    isJsonString(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
    },
    async checkSymbols() {
      const symbols = localStorage.getItem('symbols') || '';
      const symbolList = this.isJsonString(symbols) ? JSON.parse(symbols) : [];

      if (symbolList.length > 0) {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const timespan = yesterday.getTime();
        const symbolsTimespan = localStorage.getItem('symbols_timespan');

        if (symbolsTimespan < timespan) {
          await this.setSymbols();
        } else {
          this.$store.commit('set', ['symbols', symbolList]);
        }
      } else {
        await this.setSymbols();
      }
    },
    async initData(token, isExport) {
      this.isExport = isExport;
      this.$store.commit('set', ['token', token]);
      await this.checkSymbols();
  
      this.symbolCode = this.$route.query.symbol;

      if (!this.symbolCode) {
        this.symbolCode = 'MTRKS'
      }
      await this.getData();
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      });
      this.screenWidth =  window.innerWidth;
    },
    numberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getChartTitle(def) {
      let key = '';
      if (this.result.isHalfYearPeriod) {
        key = `${this.lang}_half`;
      } else {
        let periods = this.result.lastFivePeriods?.map(p => p.period) || 0;
        periods = periods.sort((a, b) => b - a);

        if (periods.length >= 2 && this.$commonHelper.getUsablePrevPeriod(periods[0]) != periods[1]) {
          key = `${this.lang}_yearly`;
        } else {
          key = this.lang;
        }
      }
      const key_alternative = `${key}_alternative`;

      if (this.$store.state.alternative_title_symbols.includes(this.symbolCode) && def[key_alternative]) {
        return def[key_alternative];
      }

      return def[key];
    },
    hasMillion(periodicData, defs) {
      const allValuesAreMillion = defs.every(def => {
        const value1 = periodicData[0] ? Math.abs(periodicData[0][def.value]) : 0;
        const value2 = periodicData[1] ? Math.abs(periodicData[1][def.value]) : 0;
        return (value1 == 0 || value1 >= 1000000) && (value2 == 0 || value2 >= 1000000)
      });
      return allValuesAreMillion;
    },
    getInflationAdjustmentPeriods(result) {
      if (!this.result.isUnadjustedSymbol && result.lastFivePeriods?.length > 0 && result.lastFivePeriods.some(l => l.period == this.$store.state.exceptionalPeriods.period)) {
        return this.$store.state.exceptionalPeriods.paintPeriods;
      }

      return null;
    },
    selectPeriod(item) {
      this.period = item.key;
      this.getBars();
    },
    getPeriodAriaLabel(item) {
      const state = this.period === item.key
        ? this.labelDefinition.a11ySelected[this.lang]
        : this.labelDefinition.a11yNotSelected[this.lang];
      return `${item.value}, ${state}`;
    },
    getPanelTitle(def) {
      const key = `${this.lang}_alternative`;

      if (this.$store.state.alternative_title_symbols.includes(this.symbolCode) && def[key]) {
        return def[key];
      }

      const val = def[this.lang];
      if (typeof val == 'function') {
        return def[this.lang](this.screenWidth)
      } else {
        return val;
      }
    }
  }
}
</script>